// extracted by mini-css-extract-plugin
module.exports = {"swipeableContainer":"swipeable_swipeableContainer__3h7HN","backgroundElement":"swipeable_backgroundElement__tiKxx"};